export const flowDataTypes = [
  'device',
  'protocol',
  'location',
  'site',
  'sensor',
] as const;

export type FlowDataType = (typeof flowDataTypes)[number];

const flowDataTypeChecker: Set<string> = new Set(flowDataTypes);

export const isFlowDataType = (
  value: string | undefined,
): value is FlowDataType =>
  value !== undefined && flowDataTypeChecker.has(value);
